export const Endpoints = {
  stores: {
    getByDocument: (storeIDOrDocument: string) => `/v3/stores/${storeIDOrDocument}`,
    getById: (id: string) => `/v3/stores/${id}`,
    update: (id: string) => `/v1/stores/${id}`
  },
  sales: {
    getAllPaymentLayerSales: (cnpj: string) => `/v1/organizations/${cnpj}/sales`,
    getPaymentLayerSaleById: (cnpj: string, saleId: string) => `/v1/organizations/${cnpj}/sales/${saleId}`,
    getPaymentLayerSalesResume: (cnpj: string) => `/v1/organizations/${cnpj}/sales-resume`
  },
  clients: {
    getAll: (id: string) => `/v1/stores/${id}/customers`
  }
} as const
